var React = require('react');

function IconPaperless (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m38.38 85.72v-71.4a4 4 0 0 1 4-4h48a4 4 0 0 1 4 4v92a4 4 0 0 1 -4 4h-32.38","key":0}),React.createElement("path",{"d":"m42.91 84.75v-61.98h46.94v75.1h-29.59","key":1}),React.createElement("path",{"d":"m49.93 61.6c0-9.08 16.45-29.1 16.45-29.1s16.45 20 16.45 29.1a16.45 16.45 0 1 1 -32.9 0z","key":2}),React.createElement("path",{"d":"m66.38 44.44v43.56","key":3}),React.createElement("path",{"d":"m74.82 63.12-8.44 8.43-8.44-8.43","key":4}),React.createElement("path",{"d":"m74.82 52.67-8.44 8.44-8.44-8.44","key":5}),React.createElement("path",{"d":"m58 110.16a16.49 16.49 0 1 1 2.65-9 16.47 16.47 0 0 1 -2.65 9","key":6}),React.createElement("path",{"d":"m36.19 101.16 4.39 5.61 11.21-11.39","key":7})]);
}

IconPaperless.defaultProps = {"viewBox":"0 0 128 128"};

module.exports = IconPaperless;

IconPaperless.default = IconPaperless;
